import {
  fetch_user_list as fetch_user_client_list
} from '@/api/communication' 
export const  UserMixins = {
  data () {
    return {
      userList:[],
      clientList:[]
    }
  },
  methods:{
    async fetch_user_client_list (type) {

      //console.log(this.type)
      //console.log(type)
  
      try {
        this.$vs.loading()
        const customer_id = localStorage.getItem('customer_id')
        const data = await fetch_user_client_list(customer_id, type)
        //console.log(data.data.data.results)
        if (type === 'User') {
          this.userList = data.data.data.results
          this.userList = this.userList.map(ele => {
            return {
              fullName:`${ele.first_name} ${ele.last_name}`,
              user_id: ele.user_id,
              user_type: 1
            }
          })
        } else if (type === 'Client') {
          this.clientList = data.data.data.results
          this.clientList = this.clientList.map(ele => {
            return {
              fullName:`${ele.first_name} ${ele.last_name}`,
              user_id: ele.user_id,
              user_type: 1
            }
          })
        }

        return true
          
      } catch (error) {
        console.log(error)
      } finally {
        this.$vs.loading.close()
      }
    }
  }
}